import axios from 'axios';

export default {
    sendLog: (log) => {
        axios({
            url:
                "/api/error?msg=" + log,
            method: "GET"
        });
    },
    addLogging: () => {
        console.log("adding logging");
        window.onerror = function (message, source, lineno, colno, error) {
            console.log("sending error");
            axios({
                url:
                    "/api/error?msg=" +
                    encodeURIComponent(
                        "message: " +
                        message +
                        "\nsource: " +
                        source +
                        "\nlineno: " +
                        lineno +
                        "\ncolno: " +
                        colno +
                        "\nerror: " +
                        error
                    ),
                method: "GET"
            });

        }
    }
}